import { render } from "./Accordion.vue?vue&type=template&id=5a96d2aa&ts=true"
import script from "./Accordion.vue?vue&type=script&lang=ts"
export * from "./Accordion.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/agtalpai/Munka/hba/hba-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__